import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { TranslatePipe } from '@ngx-translate/core'

import { EditorThread } from '../../editor-thread.types'
import { getFirstComment } from '../../editor-thread.selectors'
import { SuggestionMetaComponent } from '../../suggestion-meta/suggestion-meta.component'
import { ThreadCommentsComponent, ThreadCommentsCurrentUser } from '../thread-comments/thread-comments.component'

@Component({
  selector: 'app-comment-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslatePipe, SuggestionMetaComponent, ThreadCommentsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './comment-card.component.html',
  styleUrl: './comment-card.component.scss',
})
export class CommentCardComponent {
  @Input({ required: true })
  anchorId!: string

  @Input({ required: true })
  quotedText!: string

  @Input({ required: true })
  orphaned!: boolean

  @Input({ required: true })
  isDraft!: boolean

  @Input({ required: true })
  authorName!: string | null

  @Input({ required: true })
  createdAtRelative!: string | null

  @Input({ required: true })
  highlighted!: boolean

  @Input({ required: true })
  thread!: EditorThread | null

  @Input({ required: true })
  currentUser!: ThreadCommentsCurrentUser

  @Input({ required: true })
  canPostComment!: boolean

  @Input({ required: true })
  canResolve!: boolean

  @Output()
  view = new EventEmitter<string>()

  @Output()
  resolve = new EventEmitter<string>()

  @Output()
  discard = new EventEmitter<string>()

  @Output()
  submitComment = new EventEmitter<string>()

  get hasComments(): boolean {
    return (this.thread?.comments.length ?? 0) > 0
  }

  get firstCommentBody(): string | null {
    return getFirstComment(this.thread)?.body ?? null
  }

  onView() {
    this.view.emit(this.anchorId)
  }

  onResolve() {
    this.resolve.emit(this.anchorId)
  }

  onDiscard() {
    this.discard.emit(this.anchorId)
  }

  onCardClick(event: MouseEvent) {
    const target = event.target as HTMLElement | null
    if (target?.closest('button, input, textarea, a, select, label, [contenteditable="true"]')) {
      return
    }
    if (!this.orphaned) {
      this.onView()
    }
  }

  onSubmitComment(body: string) {
    this.submitComment.emit(body)
  }
}
